import { useFlags } from 'config/useFlagsContext'
import { isEmpty } from 'lodash'
import React from 'react'

import { MChatRfAccordionSection } from '../../components/MChatRfAccordionSection'
import { MChatRfAccordionStepper } from '../../components/MChatRfAccordionStepper'
import { MChatAccessDocLink } from '../../mchat/components/MChatAccessDocLink'
import { MChatRfAccordionSectionEnum } from '../../model-mChatRf'
import { ConsultaSeguimentoViewModel } from '../model-consultaSeguimento'

interface ConsultaSeguimentoViewProps {
  value: ConsultaSeguimentoViewModel
  isMChatRiscoMedio: boolean
}

export function ConsultaSeguimentoView(props: Readonly<ConsultaSeguimentoViewProps>) {
  const { value, isMChatRiscoMedio } = props

  const { M_CHAT_RF_ENABLED } = useFlags()

  const hasValues = !isEmpty(value)

  return (
    <MChatRfAccordionSection
      section={MChatRfAccordionSectionEnum.CONSULTA_SEGUIMENTO}
      value={value}
      isConsultaSeguimentoAtiva={hasValues || isMChatRiscoMedio}
      primaryActions={!M_CHAT_RF_ENABLED && <MChatAccessDocLink />}
      stepper={
        <MChatRfAccordionStepper
          showPendingIcon={!hasValues && !isMChatRiscoMedio}
          showCheckIcon={hasValues}
          showConnector={false}
          showInfoIcon={!hasValues && isMChatRiscoMedio}
        />
      }
    />
  )
}
